import React from 'react'
import AmbulatoryDocumentsLayout from 'presentation/doctor/layouts/AmbulatoryDocuments'

function AmbulatoryDocuments() {
  return <AmbulatoryDocumentsLayout />
}

export default AmbulatoryDocuments
